import { Component } from '@angular/core';
import { AuthService } from 'smartenit-angular-sdk';
import { Router } from '@angular/router';

@Component({
    templateUrl: './main.html',
    styleUrls: ['./main.scss']
})
export class MainComponent {
    
    public constructor(
    ){
        
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/main/main.ts